import { css } from '@emotion/core';
import { colorsPalette, shadows } from '../../../styles/colors';

export const baseZoomControls = css({
  alignItems: 'center',
  background: colorsPalette.white,
  border: 0,
  boxShadow: shadows.shadow40,
  cursor: 'pointer',
  display: 'flex',
  height: 30,
  justifyContent: 'center',
  width: 28,
});

export const underline = css({
  borderBottom: `1px solid ${colorsPalette.grey20}`,
  bottom: 0,
  left: 0,
  margin: 'auto',
  position: 'absolute',
  right: 0,
  width: '80%',
});

export const minusIcon = css({
  borderBottom: `1px solid ${colorsPalette.black}`,
  width: 14,
});

export const plusIcon = css({
  fontSize: 14,
});
